import { createTheme } from '@mui/material/styles';
import { colors } from '@mui/material';

import shadows from './shadows';
import typography from './typography';

const theme = createTheme({
  palette: {
    background: {
      default: '#F4F6F8',
      paper: colors.common.white
    },
    primary: {
      contrastText: '#ffffff',
      main: '#1778f2'
    },
    secondary: {
      contrastText: '#ffffff',
      main: '#050a4e'
    },
    text: {
      primary: '#050a4e',
      secondary: '#050a4e'
    }
  },
  shadows,
  typography,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 15,
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#1778f2'
        },
        root: {
          borderRadius: 15,
        },
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: 'white'
        }
      }
    },
    // MuiFormHelperText: {
    //   styleOverrides: {
    //     root: {
    //       display: 'none'
    //     }
    //   }
    // }
  }
});

theme.components.MuiOutlinedInput = {
  styleOverrides: {
    root: {
      borderRadius: 10,
      boxShadow: '0 0 4px rgba(0,0,0,0.20)',
      backgroundColor: 'white',
      fieldset: {
        borderColor: 'white',
      },
      // '&:hover': {
      //   fieldset: {
      //     'border-color': 'blue',
      //   }
      // }
    },
  },
  defaultProps: {
    size: 'small'
  },
}
export default theme;
